/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InsightCategory } from './insightCategory';


/**
 * Classification of the insight, shown as a labelled badge on the summary card. Groups insights by theme (for example \'Repeat Offender Risk\') and conveys urgency via severity.
 */
export interface Category { 
    /**
     * Short human-readable category name shown on the card badge, from the InsightCategory catalogue, for example \'Driver Risk\'.
     */
    label: InsightCategory;
    /**
     * Urgency level driving the badge colour. \'error\' is the most urgent, \'warning\' indicates attention needed, \'info\' is neutral context, and \'success\' indicates a positive or resolved state.
     */
    severity: Category.SeverityEnum;
}
export namespace Category {
    export const SeverityEnum = {
        Warning: 'warning',
        Error: 'error',
        Info: 'info',
        Success: 'success'
    } as const;
    export type SeverityEnum = typeof SeverityEnum[keyof typeof SeverityEnum];
}


